export function createAppError(code, message, retryable = false, metadata) {
    return {
        code,
        message,
        retryable,
        ...(metadata ? { metadata } : {}),
    };
}
